$(document).ready(function() {

    /* PARSLEY */
    if ($('.ttgAnfrageForm').length) {
        $('.ttgAnfrageForm').parsley();
    }

    window.Parsley.on('field:error', function() {
        this.$element.attr('aria-describedby', this._ui.errorsWrapperId).attr('aria-invalid', 'true');
    });

    window.Parsley.on('field:success', function() {
        if (this.$element.attr('aria-invalid')) {
            this.$element.removeAttr('aria-invalid');
        }
    });

    /* SUBMIT */
    $(".ttgAnfrageForm")
        .on('submit', function(e) {

            // Default-Reaktion unterbinden und AJAX-Post ausführen
            e.preventDefault();

            var $form = $(this),
                lang = $form.attr('data-lang'),
                formularWrapperID = $form.parent().data('id'),
                ajaxLoader = $form.parent().prev().attr('class'),
                currentURL = $form.find("input[name='currenturl']").val(),
                currentURLclean = currentURL.split('?');

            // Überprüfung, ob alle Felder korrekt befüllt sind (Parsley)
            if ($form.find('ul.filled').length > 0) {
                return;
            } else {

                //ReCaptcha V3
                grecaptcha.ready(function() {
                    grecaptcha.execute($(".ttgAnfrageFormular").find('.google-recaptcha').data('sitekey'), {
                        action: 'submit'
                    }).then(function(token) {
                        $('.ttgAnfrageFormular input[type="hidden"][name="g-recaptcha-response"]').val(token);
                        $.ajax({
                            type: "POST",
                            url: "/?type=3791&L=" + lang,
                            data: $form.serialize(),
                            beforeSend: function() {
                                // Ladezustand anzeigen
                                $("." + ajaxLoader).show();

                                // Senden-Button entfernen, um Double-Click zu vermeiden
                                $(".ttgAnfrageFormSubmitButton").remove();
                            },
                            success: function(result) {
                                if ($("#ttgAnfrageResult" + formularWrapperID)) {
                                    $("#ttgAnfrageFormular" + formularWrapperID).remove();
                                    $("#ttgAnfrageResult" + formularWrapperID).html(result);
                                } // if

                                // Ladezustand verstecken
                                $("." + ajaxLoader).hide();
                                trackEvent('Formular', 'Senden', currentURLclean[0]);
                            },
                            error: function() {
                                trackEvent('Formular', 'Fehler', currentURLclean[0]);
                            }
                        });
                    });
                });

            }

        })
        .find('.ttgAnfrageFormSubmitButton').on('click', function(e) {
            var $form = $(this).closest('form');
            setTimeout(function() {
                if ($form.find('ul.filled').length > 0) {
                    trackEvent('Formular', 'Invalid', $form.find("input[name='currenturl']").val().split('?')[0]);
                }
            }, 1000);
        });

    // Submit-Button deaktivieren, wenn Indiv-Formular abgeschickt wird
    $('.frame-type-form_formframework form').on('submit', function(e) {
        const $form = $(this);
        setTimeout(function() {
            $form.find('.submit button[type="submit"]').prop('disabled', true);
        }, 0);
    });
});

if ($('.ttgFormBuchungsblock').length) {
    // Reisezeitraum unbekannt - Checkbox
    $('.ttgFormReisezeitraumUnbekannt').change(function() {
        $('#anreise').prop('disabled', function(i, v) {
            return !v;
        });
        $('#abreise').prop('disabled', function(i, v) {
            return !v;
        });
    });
}